// app/javascript/controllers/slug_controller.js
import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["name", "input"];

  connect() {
    if (this.hasInputTarget) this.formatLive(); // formatea al cargar (edit)
  }

  // Sugerir desde el nombre si el campo code está vacío
  suggestFromName() {
    if (!this.hasNameTarget || !this.hasInputTarget) return;
    if (this.inputTarget.value.trim().length > 0) return;
    this.inputTarget.value = this.slugFromName(this.nameTarget.value);
  }

  // Normalización "en vivo": NO recorta guiones iniciales/finales
  formatLive() {
    if (!this.hasInputTarget) return;
    this.inputTarget.value = this.liveSanitize(this.inputTarget.value);
  }

  // Normalización final (al salir del campo): recorta guiones extremos
  finalize() {
    if (!this.hasInputTarget) return;
    let v = this.finalSanitize(this.inputTarget.value);

    // Si quedó vacío, intenta sugerir desde nombre
    if (v.length === 0 && this.hasNameTarget) {
      v = this.slugFromName(this.nameTarget.value);
    }

    this.inputTarget.value = v;
  }

  // Forzar guion ASCII si el teclado emite dashes Unicode
  forceAsciiDash(event) {
    if (event.key === "-") return;
    const dashLike = /[–—−‐‒﹘﹣－]/; // distintos dashes Unicode
    if (dashLike.test(event.key)) {
      event.preventDefault();
      this.insertAtCursor("-");
    }
  }

  onPaste(event) {
    if (!this.hasInputTarget) return;
    event.preventDefault();
    const text = (event.clipboardData || window.clipboardData).getData("text");
    const normalized = this.finalSanitize(text);
    this.insertAtCursor(normalized, { replaceAll: true });
  }

  // Helpers
  insertAtCursor(text, { replaceAll = false } = {}) {
    const el = this.inputTarget;
    const [start, end] = [el.selectionStart, el.selectionEnd];
    if (replaceAll) {
      el.value = text;
    } else {
      el.value = el.value.slice(0, start) + text + el.value.slice(end);
      el.selectionStart = el.selectionEnd = start + text.length;
    }
    el.dispatchEvent(new Event("input", { bubbles: true }));
  }

  // Genera un slug base desde nombre
  slugFromName(value) {
    return this.finalSanitize(value);
  }

  // ---- Normalizadores ----
  // En vivo: sin recorte de extremos
  liveSanitize(value) {
    if (!value) return "";
    let v = String(value).toLowerCase().trim();
    v = v.normalize("NFD").replace(/\p{Diacritic}/gu, "");
    v = v.replace(/[–—−‐‒﹘﹣－]/g, "-"); // dashes Unicode -> '-'
    v = v
      .replace(/\s+/g, "-") // espacios -> '-'
      .replace(/[^a-z0-9-]/g, "") // solo a-z0-9-
      .replace(/-+/g, "-"); // colapsar ---
    // OJO: NO quitamos guiones al inicio/fin aquí
    if (v.length > 32) v = v.slice(0, 32);
    return v;
  }

  // Final: recorta extremos y aplica límites
  finalSanitize(value) {
    let v = this.liveSanitize(value);
    v = v.replace(/^-+|-+$/g, ""); // ahora sí recorta extremos
    if (v.length > 32) v = v.slice(0, 32);
    return v;
  }
}
